import { render, staticRenderFns } from "./UnsubscribeForm.vue?vue&type=template&id=5b0013c1&scoped=true"
import script from "./UnsubscribeForm.vue?vue&type=script&lang=js"
export * from "./UnsubscribeForm.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeForm.vue?vue&type=style&index=0&id=5b0013c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0013c1",
  null
  
)

export default component.exports